import script from "./VitrineHeaderNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./VitrineHeaderNotification.vue?vue&type=script&setup=true&lang=js"

import "./VitrineHeaderNotification.vue?vue&type=style&index=0&id=3a72ef0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a72ef0f"]])

export default __exports__